import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/698660ba921dc90014fe0c75/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698660ba921dc90014fe0c75/website_project/src/app/reports/components/ReportsDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698660ba921dc90014fe0c75/website_project/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698660ba921dc90014fe0c75/website_project/src/components/ui/AppIcon.tsx");
